import React from 'react';
import '../App.css';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className='hero-container'>
      <h1 className='title'>Arte Crochê Natal</h1>
      <p className='p1'>Especialista em lembrancinhas, kit higiene e bolsas</p>
      <p className='p2'>Enviamos para todo o Brasil</p>
      <div className='hero-btns'>
      </div>
    </div>
  );
}

export default HeroSection;
